import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-used-token-feedback',
  templateUrl: './used-token-feedback.component.html',
  styleUrls: ['./used-token-feedback.component.scss']
})
export class UsedTokenFeedbackComponent implements OnInit {

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor() { }

  ngOnInit(): void {
  }

}
